import { Dispatch, Action } from 'redux'
import { TaskStatusSelectFieldMapDispatchReturnType } from './types/TaskStatusSelectFieldMapDispatchReturnType'

export const TaskStatusSelectFieldMapDispatch = (
  _dispatch: Dispatch<Action>
): TaskStatusSelectFieldMapDispatchReturnType => {
  return {}
}
